/* eslint-disable max-len */

import React from 'react';
import { Content, Button, Flex, Text, TextInput, Label, Pane } from '@leverege/ui-elements';
import { TitleBar } from '@leverege/ui-plugin';
import { Config } from '@leverege/plugin';
import C from '../salesFlow/Constants';
import S from './PairingFlow.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const options = [{
  label: C.SALE_NAMES.VEHICLE_ONLY,
  value: C.SALE_TYPES.VEHICLE_ONLY
}, {
  label: C.SALE_NAMES.VEHICLE_WHOLESALE,
  value: C.SALE_TYPES.VEHICLE_WHOLESALE
}, {
  label: C.SALE_NAMES.DEALER_TRADE,
  value: C.SALE_TYPES.DEALER_TRADE
}, {
  label: C.SALE_NAMES.VEHICLE_WITH_LOCATOR,
  value: C.SALE_TYPES.VEHICLE_WITH_LOCATOR
}];
export default function UnpairSaleForm(props) {
  const {
    areaClassName,
    footerClassName,
    onClose,
    onChange,
    onUnpair,
    titleVariant,
    titleIcon,
    asset,
    trackerId,
    trackerInstallLocation,
    unpairReason,
    customerName,
    salesperson
  } = props;
  const label = options.find(option => option.value === unpairReason).label;
  let message, primaryButtonText;
  if (asset?.data?.pendingSaleId) {
    message = `This vehicle is currently marked as a pending "${label}" sale. Once unpaired, the sale will complete, and this vehicle will be removed from your RecovR vehicle inventory. Please remove the locator from the vehicle before the vehicle leaves the lot.`;
    primaryButtonText = 'Unpair';
  } else {
    message = `This vehicle will be marked as a "${label}" sale. Please remove the locator from the vehicle. Once unpaired this vehicle will be removed from your inventory.`;
    primaryButtonText = 'Complete Sale & Unpair';
  }
  return /*#__PURE__*/_jsxs(React.Fragment, {
    children: [/*#__PURE__*/_jsxs(Content.Header, {
      children: [/*#__PURE__*/_jsx(TitleBar, {
        variant: titleVariant,
        title: "Unpair Locator from Vehicle",
        "data-cy": Config.get('cypress', ['text', 'locator.unpairFromVehicle'], 'text.locator.unpairFromVehicle'),
        icon: titleIcon
      }), /*#__PURE__*/_jsx(Button, {
        variant: "closeDialog",
        className: S.close,
        onClick: onClose
      })]
    }), /*#__PURE__*/_jsx(Content.Area, {
      className: areaClassName,
      children: /*#__PURE__*/_jsxs(Flex, {
        variant: "colL",
        children: [/*#__PURE__*/_jsx(Label, {
          variant: "sectionTitle",
          children: label
        }), /*#__PURE__*/_jsx(Text, {
          className: S.body,
          children: message
        }), (unpairReason === C.SALE_TYPES.VEHICLE_WHOLESALE || unpairReason === C.SALE_TYPES.DEALER_TRADE) && /*#__PURE__*/_jsxs(Flex, {
          variant: "colS",
          children: [/*#__PURE__*/_jsx(Label, {
            variant: "inputTitle",
            children: "Customer Name"
          }), /*#__PURE__*/_jsx(TextInput, {
            eventData: "customerName",
            onChange: onChange,
            value: customerName
          })]
        }), /*#__PURE__*/_jsxs(Flex, {
          variant: "colS",
          children: [/*#__PURE__*/_jsx(Label, {
            variant: "inputTitle",
            children: "Salesperson"
          }), /*#__PURE__*/_jsx(TextInput, {
            eventData: "salesperson",
            onChange: onChange,
            value: salesperson
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: S.divider
        }), /*#__PURE__*/_jsxs(Flex, {
          variant: "colM",
          children: [/*#__PURE__*/_jsx(Label, {
            variant: "sectionTitle",
            children: "Locator Information"
          }), /*#__PURE__*/_jsxs(Pane, {
            className: S.container,
            layout: "flex:colM",
            children: [/*#__PURE__*/_jsxs(Flex, {
              variant: "row",
              justify: "space-between",
              children: [/*#__PURE__*/_jsx(Text, {
                className: S.name,
                children: "Locator Id"
              }), /*#__PURE__*/_jsx(Text, {
                className: S.value,
                children: trackerId
              })]
            }), /*#__PURE__*/_jsxs(Flex, {
              variant: "row",
              justify: "space-between",
              children: [/*#__PURE__*/_jsx(Text, {
                className: S.name,
                children: "Install Location"
              }), /*#__PURE__*/_jsx(Text, {
                className: S.value,
                children: trackerInstallLocation
              })]
            })]
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: S.divider
        }), /*#__PURE__*/_jsxs(Flex, {
          variant: "colM",
          children: [/*#__PURE__*/_jsx(Label, {
            variant: "sectionTitle",
            children: "Vehicle Information"
          }), /*#__PURE__*/_jsxs(Pane, {
            className: S.container,
            layout: "flex:colL",
            children: [/*#__PURE__*/_jsxs(Flex, {
              variant: "rowM",
              children: [/*#__PURE__*/_jsxs(Flex, {
                variant: "colM",
                className: S.nameValueContainer,
                children: [/*#__PURE__*/_jsx(Text, {
                  className: S.name,
                  children: "VIN"
                }), /*#__PURE__*/_jsx(Text, {
                  className: S.value,
                  children: asset?.data?.vin
                })]
              }), /*#__PURE__*/_jsxs(Flex, {
                variant: "colM",
                className: S.nameValueContainer,
                children: [/*#__PURE__*/_jsx(Text, {
                  className: S.name,
                  children: "Stock Number"
                }), /*#__PURE__*/_jsx(Text, {
                  className: S.value,
                  children: asset?.data?.stocknumber
                })]
              })]
            }), /*#__PURE__*/_jsxs(Flex, {
              variant: "row",
              children: [/*#__PURE__*/_jsxs(Flex, {
                variant: "colM",
                children: [/*#__PURE__*/_jsx(Text, {
                  className: S.name,
                  children: "Make, Model, Year"
                }), /*#__PURE__*/_jsx(Text, {
                  className: S.value,
                  children: `${asset?.data?.make} ${asset?.data?.model} ${asset?.data?.year}`
                })]
              }), /*#__PURE__*/_jsx(Flex, {
                variant: "colM"
              })]
            })]
          })]
        })]
      })
    }), /*#__PURE__*/_jsxs(Content.Footer, {
      className: footerClassName,
      layout: "flex:rowMEnd",
      children: [/*#__PURE__*/_jsx(Button, {
        onClick: onClose,
        variant: "secondary",
        children: "Cancel"
      }), /*#__PURE__*/_jsx(Button, {
        variant: "primary",
        onClick: onUnpair,
        disabled: (unpairReason === C.SALE_TYPES.VEHICLE_WHOLESALE || unpairReason === C.SALE_TYPES.DEALER_TRADE) && !customerName,
        children: primaryButtonText
      })]
    })]
  });
}